import i18n from 'translations'

import RegistrationForm from './RegistrationForm'

export const ROUTE_NAMES = {
  'REGISTRATION_FORM.INDEX': 'REGISTRATION_FORM.INDEX',
}

const RegistrationFormRouting = [
  {
    indexRoute: {
      component: RegistrationForm,
      disableAuth: true,
    },
    name: ROUTE_NAMES['REGISTRATION_FORM.INDEX'],
    noBreadcrumb: true,
    path: 'registration-form/:id',
    title: i18n.t('module:RegistrationForm:title'),
  },
] as any

RegistrationFormRouting.ROUTE_NAMES = ROUTE_NAMES

export default RegistrationFormRouting
